export const AGE_VALIDATION_TYPE = {
  DATE_OF_BIRTH: 'DATE_OF_BIRTH',
  IS_OF_AGE: 'IS_OF_AGE',
};

export const AGE_VALIDATION_MODAL_TYPE = 'age_validation';

export const AGE_VALIDATION_MODAL_ACTION = {
  CLOSED: 'closed',
  COMPLETED_UNDERAGE: 'completed_underage',
  COMPLETED_ADULT: 'completed_adult',
};

export const AGE_VALIDATION_MODAL_CLICK = {
  OUTSIDE: 'outside',
  SUBMIT: 'submit',
  BUTTON: 'button',
  HIGHER: 'mayor',
  LESS: 'menor',
  CLOSED: 'closed',
};
